import React, {Fragment} from 'react';
import { Link } from "react-router-dom";
import Notification from './Notification';
import {LoadingBar} from "../../Loader";
import {useInfiniteQuery, useMutation, useQueryClient} from "@tanstack/react-query";
import {
    fetchUnreadNotifications,
    fetchUserNotifications,
    markUserNotificationOpen,
    USER_NOTIFICATIONS_KEY, USER_UNREAD_NOTIFICATIONS_KEY
} from "../../../../api/public-voissa/users";
import _ from "lodash";


const NotificationsList = ({
        isPage = false,
        handleCloseDropdown = () =>{}
    }) =>{

    let filter = {
        limit: isPage ? 100 : 20,
        lastId: null
    };

    const queryClient = useQueryClient();

    const {
        mutate : mutateReadAllNotification,
    } = useMutation(() => fetchUnreadNotifications(),{
        onSuccess: (data) =>{
            queryClient.setQueryData([USER_UNREAD_NOTIFICATIONS_KEY], () =>{
                return {
                    total : 0,
                }
            })
        }
    });

    const {isSuccess : isSuccessNotifications, isFetchingNextPage : isFetchedNotifications, data : dataNotifications, fetchNextPage : fetchNextPageNotifications, hasNextPage : hasNextPageNotifications} = useInfiniteQuery(
        [USER_NOTIFICATIONS_KEY, {isPage}],
        ({pageParam = null}) => fetchUserNotifications({...filter, lastId : pageParam}),
        {
            onSuccess : () =>{
                mutateReadAllNotification()
            },
            getNextPageParam: (lastPage, pages) => lastPage && lastPage.more ? lastPage.lastId : null
        }
    );



    const {
        mutate : mutateReadNotification,
    } = useMutation(notificationId => markUserNotificationOpen(notificationId),{
        onSuccess: (data) =>{

            const queryCache = queryClient.getQueryCache()
            const queryKeys = queryCache.getAll().map(cache => cache.queryKey).filter(cache => cache[0] === USER_NOTIFICATIONS_KEY);

            queryKeys.forEach(queryKey =>{
                const previousValue = queryClient.getQueryData(queryKey);
                if(previousValue){
                    const newPagesArray = previousValue?.pages.map((page) => {
                            page.data = page.data.map((item) => {
                                if(item._id.toString() === data._id.toString()){
                                    item = {...item, open : true};
                                }
                                return item;
                            });
                            return page;
                        }
                    ) ?? []

                    queryClient.setQueryData(queryKey, oldData => ({
                        pages: newPagesArray,
                        pageParams: oldData.pageParams,
                    }));
                }
            });

        }
    });

    let totalNotification = _.get(dataNotifications,'pages[0].total') || 0;

    return (
        <>
            <div className="notifications-list" onClick={handleCloseDropdown}>
                {isFetchedNotifications && <LoadingBar/>}
                {totalNotification === 0 ? (
                        <div className="no-content">Aucune notification pour le moment</div>
                    ) :
                    isSuccessNotifications && dataNotifications.pages.map((group, i) => (
                        <Fragment key={i}>
                            {group.data.map((notification, index) => (
                                <Notification
                                    key={index}
                                    data={notification}
                                    onOpen={() => {
                                        handleCloseDropdown();
                                        if (!notification.open) mutateReadNotification(notification._id);
                                    }}/>
                            ))}
                        </Fragment>
                    ))
                }
            </div>
            {isFetchedNotifications ? <LoadingBar /> : null}
            {isPage && hasNextPageNotifications ? <div className="see-more-notifications" onClick={() => fetchNextPageNotifications()}>Afficher plus de notifications</div> : null}
            {!isPage && (
                <div className="see-more-notifications" onClick={handleCloseDropdown}>
                    <Link to="/notifications">Voir toutes les notifications</Link>
                </div>)}
        </>
    )
};

export default NotificationsList;